export const contactsData = {
  email: 'rafaelfelipe.r@hotmail.com',
  phone: '+55 31 99186-9943',
  address: 'Belo Horizonte, MG - Brasil',

  sheetAPI: 'https://sheetdb.io/api/v1/xjvsc9ie65m52',
}; export default contactsData;
